<template>
  <div class="card-wrapper">
    <div>
      <PrimaryCard>
        <img
          height="45px"
          width="115px"
          src="//attach-videos.s3.amazonaws.com/mikmak-logo-teal.png">
        <p>Oh no!</p>
        <p> {{email}} has not been set up for access to Platform</p>
      </PrimaryCard>
    </div>
  </div>
</template>

<script>
import { PrimaryCard } from '@mikmak/components';
import utils from '../../services/utils';

export default {
  components: {
    PrimaryCard,
  },
  data() {
    const email = decodeURIComponent(utils.getQueryParam('email'));

    return {
      email: email !== 'undefined' ? email : 'Account',
    };
  },
};
</script>

<style scoped>
.card-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 16px;
  height: 100vh;
}
</style>
